import api from './api';

export interface CreateManualFlightCheckoutDto {
  passengers: {
    firstName: string;
    lastName: string;
    documentType: 'CPF' | 'PASSPORT';
    documentNumber: string;
    birthDay: string;
    birthMonth: string;
    birthYear: string;
    gender: 'male' | 'female';
    country?: string;
  }[];
  contact: {
    email: string;
    confirmEmail: string;
    areaCode?: string;
    phoneNumber: string;
  };
  payment: {
    type: 'pix' | 'credit_card' | 'debit_card' | 'kairu' | 'zartoes';
  };
  invoice: {
    type: 'individual' | 'company';
  };
  flight: {
    tripType: 'one_way' | 'round_trip';
    outboundFlightId: string;
    outboundFareId: string;
    returnFlightId?: string;
    returnFareId?: string;
    route: string;
    date: string;
    returnDate?: string;
    passengers: number;
    airline: string;
    duration: string;
    departureTime: string;
    arrivalTime: string;
    departureLocation: string;
    arrivalLocation: string;
    returnDepartureTime?: string;
    returnArrivalTime?: string;
    outboundFlight: {
      uniqueId: string;
      flightNumber: string;
      airlineName: string;
      airlineCode?: string;
      departureLocation: string;
      arrivalLocation: string;
      departureTime: string;
      arrivalTime: string;
      flightDuration: string;
      ourPrice: number;
      tax: number;
      qntStop: number;
      cabin?: string;
      stops: {
        stopOrder: number;
        op: string;
        isEscale: boolean;
        flightNumber: string;
        departureTime: string;
        arrivalTime: string;
        departureLocation: string;
        arrivalLocation: string;
        flightDuration: string;
        timeWaiting?: string;
        companyCode?: string;
        cabin?: string;
        qntEscale: number;
      }[];
    };
    returnFlight?: {
      uniqueId: string;
      flightNumber: string;
      airlineName: string;
      airlineCode?: string;
      departureLocation: string;
      arrivalLocation: string;
      departureTime: string;
      arrivalTime: string;
      flightDuration: string;
      ourPrice: number;
      tax: number;
      qntStop: number;
      cabin?: string;
      stops: {
        stopOrder: number;
        op: string;
        isEscale: boolean;
        flightNumber: string;
        departureTime: string;
        arrivalTime: string;
        departureLocation: string;
        arrivalLocation: string;
        flightDuration: string;
        timeWaiting?: string;
        companyCode?: string;
        cabin?: string;
        qntEscale: number;
      }[];
    };
  };
  pricing: {
    basePrice: number;
    taxes: number;
    total: number;
  };
  notes?: string;
}

export const flightManualCheckoutService = {
  async createManualCheckout(dto: CreateManualFlightCheckoutDto): Promise<{ checkoutId: string }> {
    const response = await api.post('/checkout/manual', dto);
    return response.data;
  },
};
